module.exports = __webpack_public_path__ + "img/price.28867739.jpg";